import api from './index.js';

api.internals.register(api.checkbox.CheckboxSelector.INPUT, api.checkbox.CheckboxInput);

export default api;
